module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/tabination/pill-style1/pill-style1.component.scss
// module id = ./src/app/features/tabination/pill-style1/pill-style1.component.scss
// module chunks = main